export enum EmployeeStatusEnum {
    DEFAULT = 'default',
    PRESENT = 'present',
    ABSENT = 'absent',
    VACATION = 'vacation',
    HOLIDAY = 'holiday',
    SHOP_CLOSED = 'shop_closed'
}

export interface Employee {
    id: string;
    firstName: string;
    lastName: string;
    position: string;
    avatar?: string;
}

export interface TimeSlot {
    id: string;
    startTime: string;
    endTime: string;
}

export interface DaySchedule {
    date: Date;
    status: EmployeeStatusEnum;
    timeSlots: TimeSlot[];
    notes?: string;
}

export interface WeeklySchedule {
    employeeId: string;
    weekStartDate: Date;
    days: Record<string, DaySchedule>; // key: YYYY-MM-DD format
}

export interface PlanningMetrics {
    totalEmployees: number;
    presentToday: number;
    absentToday: number;
    onVacationToday: number;
    weeklyPresenceRate: number;
    monthlyPresenceRate: number;
    totalWeeklyHours: number;
    averageHoursPerEmployee: number;
}

export const STATUS_CONFIG = {
    [EmployeeStatusEnum.DEFAULT]: {
        label: 'Non défini',
        color: 'bg-gray-50 border-gray-200 text-gray-600',
        bgColor: 'bg-gray-25',
    },
    [EmployeeStatusEnum.PRESENT]: {
        label: 'Présent',
        color: 'bg-green-100 border-green-200 text-green-800',
        bgColor: 'bg-green-50',
    },
    [EmployeeStatusEnum.ABSENT]: {
        label: 'Absent',
        color: 'bg-red-100 border-red-200 text-red-800',
        bgColor: 'bg-red-50',
    },
    [EmployeeStatusEnum.VACATION]: {
        label: 'En congé',
        color: 'bg-blue-100 border-blue-200 text-blue-800',
        bgColor: 'bg-blue-50',
    },
    [EmployeeStatusEnum.HOLIDAY]: {
        label: 'Jour férié',
        color: 'bg-purple-100 border-purple-200 text-purple-800',
        bgColor: 'bg-purple-50',
    },
    [EmployeeStatusEnum.SHOP_CLOSED]: {
        label: 'Boutique fermée',
        color: 'bg-gray-100 border-gray-200 text-gray-800',
        bgColor: 'bg-gray-50',
    },
};